// src/components/MedalsPage/MedalsPage.jsx
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCoins } from '../../context/CoinContext';
import { useAuth } from '../../context/AuthContext';
import { useExams } from '../Exams/ExamContext.jsx';
import { engine } from '../../core/books/storage.js';
import { getToken } from '../../utils/secureStorage.js';
import moment from 'moment-jalaali';
import DragonCelebration from './DragonCelebration';
import './MedalsPage.css';

/* ================================================================
   🐉 اژدهاها (بدون تغییر)
   ================================================================ */
const DRAGONS = [
  { id: 200, name: 'تخم اژدها',    emoji: '🥚', image: '',              size: 190,   bottom: 0,  minScore: 0,    c1: '#fbbf24', c2: '#d97706', glow: 'rgba(251,191,36,0.65)' },
  { id: 201, name: 'تازه کار',       emoji: '🦎', image: '/medals/1.png', size: 190,   bottom: 0,  minScore: 10,    c1: '#24fbd7', c2: '#06cbd9', glow: 'rgba(36, 244, 251, 0.65)' },
  { id: 202, name: 'ماجراجو',     emoji: '🦖', image: '/medals/2.png', size: 190,   bottom: 0,  minScore: 100,  c1: '#84cc16', c2: '#65a30d', glow: 'rgba(132,204,22,0.65)' },
  { id: 203, name: 'حرفه ای',     emoji: '🐲', image: '/medals/3.png', size: 190,   bottom: 0, minScore: 500,  c1: '#22d3ee', c2: '#0891b2', glow: 'rgba(34,211,238,0.65)' },
  { id: 204, name: 'قهرمان',      emoji: '🐦‍🔥', image: '/medals/4.png', size: 190,   bottom: 0, minScore: 1000, c1: '#f97316', c2: '#dc2626', glow: 'rgba(249,115,22,0.65)' },
  { id: 205, name: 'افسانه',       emoji: '🐉', image: '/medals/5.png', size: 190,   bottom: 0, minScore: 2000, c1: '#818cf8', c2: '#6366f1', glow: 'rgba(129,140,248,0.65)' },
  { id: 206, name: 'استاد',         emoji: '🔱', image: '/medals/6.png', size: 190,   bottom: 0, minScore: 3500, c1: '#bae6fd', c2: '#0284c7', glow: 'rgba(186,230,253,0.65)' },
  { id: 207, name: 'استاد بزرگ',    emoji: '🔥', image: '/medals/7.png',  size: 190,   bottom: 0, minScore: 6000, c1: '#fde047', c2: '#eab308', glow: 'rgba(253,224,71,0.65)' },
  { id: 208, name: 'اسطوره',        emoji: '👑', image: '/medals/8.png', size: 190,   bottom: 0, minScore: 10000, c1: '#e879f9', c2: '#a855f7', glow: 'rgba(232,121,249,0.65)' },
];

const IRAN_PROVINCES = [
  { name: 'تهران', cities: ['تهران','اسلامشهر','شهریار','ورامین','رباط‌کریم','پاکدشت','پردیس','دماوند','فیروزکوه','ملارد','قدس','قرچک','پیشوا','شمیرانات','کهریزک','باقرشهر'] },
  { name: 'البرز', cities: ['کرج','فردیس','هشتگرد','نظرآباد','اشتهارد','طالقان','محمدشهر','ماهدشت','گرمدره','کمال‌شهر','مشکین‌آباد','چهارباغ','آسارا'] },
  { name: 'اصفهان', cities: ['اصفهان','کاشان','خمینی‌شهر','نجف‌آباد','شهرضا','شاهین‌شهر','فولادشهر','گلپایگان','اردستان','نطنز','نایین','سمیرم','فریدن','فریدون‌شهر','چادگان','خوانسار','دهاقان','مبارکه','خور','ورزنه','کوهپایه','هرند'] },
  { name: 'خراسان رضوی', cities: ['مشهد','نیشابور','سبزوار','تربت حیدریه','قوچان','کاشمر','تربت جام','گناباد','چناران','خواف','درگز','سرخس','فریمان','بردسکن','جغتای','خلیل‌آباد','رشتخوار','زاوه','طرقبه','باخرز','بجستان','جوين','داورزن','فیروزه','کلات'] },
  { name: 'فارس', cities: ['شیراز','مرودشت','جهرم','فسا','کازرون','داراب','لار','آباده','اقلید','نی‌ریز','صفاشهر','استهبان','زرین‌دشت','سپیدان','فیروزآباد','قیر','کوار','گراش','لامرد','مهر','ممسنی','خرامه','رستم','سروستان','فراشبند'] },
  { name: 'خوزستان', cities: ['اهواز','آبادان','خرمشهر','دزفول','بهبهان','شوشتر','شوش','ایذه','مسجدسلیمان','بندر ماهشهر','رامهرمز','اندیمشک','باغ‌ملک','هندیجان','رامشیر','امیدیه','هفتکل','گتوند','لالی'] },
  { name: 'آذربایجان شرقی', cities: ['تبریز','مراغه','مرند','میانه','اهر','بناب','سراب','شبستر','آذرشهر','اسکو','بستان‌آباد','هریس','هشترود','جلفا','چاراویماق','خداآفرین','ملکان','عجب‌شیر','ورزقان','کلیبر'] },
  { name: 'آذربایجان غربی', cities: ['ارومیه','خوی','میاندوآب','مهاباد','بوکان','سلماس','نقده','پیرانشهر','ماکو','سردشت','شاهین‌دژ','تکاب','اشنویه','چالدران','پلدشت','شوط','چایپاره'] },
  { name: 'کرمان', cities: ['کرمان','رفسنجان','سیرجان','جیرفت','بم','زرند','کهنوج','بردسیر','ریگان','راور','شهربابک','عنبرآباد','فهرج','قلعه‌گنج','کوهبنان','منوجان','نرماشیر','ارزوئیه','فاریاب','رودبار جنوب'] },
  { name: 'گیلان', cities: ['رشت','بندر انزلی','لاهیجان','لنگرود','آستارا','تالش','رودسر','فومن','صومعه‌سرا','آستانه اشرفیه','املش','رودبار','سیاهکل','شفت','ماسال','خمام','سنگر','کوچصفهان','لشت نشا'] },
  { name: 'مازندران', cities: ['ساری','بابل','آمل','قائم‌شهر','بهشهر','چالوس','نوشهر','تنکابن','رامسر','نکا','جویبار','فریدون‌کنار','محمودآباد','نور','عباس‌آباد','کلاردشت','گلوگاه','سوادکوه','سیمرغ','میان‌دورود'] },
  { name: 'کرمانشاه', cities: ['کرمانشاه','اسلام‌آباد غرب','هرسین','کنگاور','سنقر','پاوه','جوانرود','سرپل ذهاب','قصر شیرین','گیلانغرب','صحنه','ثلاث باباجانی','دالاهو','روانسر'] },
  { name: 'لرستان', cities: ['خرم‌آباد','بروجرد','دورود','الیگودرز','کوهدشت','نورآباد','ازنا','پلدختر','چگنی','دلفان','سلسله','رومشکان'] },
  { name: 'گلستان', cities: ['گرگان','گنبد کاووس','بندر ترکمن','علی‌آباد','کردکوی','آق‌قلا','بندر گز','رامیان','مینودشت','کلاله','مراوه‌تپه','آزادشهر','گمیشان'] },
  { name: 'سیستان و بلوچستان', cities: ['زاهدان','زابل','چابهار','ایرانشهر','سراوان','خاش','کنارک','نیک‌شهر','سرباز','میرجاوه','قصرقند','دلگان','زهک','هیرمند','مهرستان','فنوج','سیب سوران','بمپور'] },
  { name: 'هرمزگان', cities: ['بندرعباس','قشم','کیش','میناب','بندر لنگه','بندر خمیر','رودان','بستک','پارسیان','جاسک','سیریک','حاجی‌آباد','ابوموسی','بشاگرد'] },
  { name: 'کردستان', cities: ['سنندج','سقز','مریوان','بانه','قروه','بیجار','کامیاران','دیواندره','دهگلان','سروآباد'] },
  { name: 'همدان', cities: ['همدان','ملایر','نهاوند','تویسرکان','اسدآباد','بهار','کبودرآهنگ','رزن','لالجین','فامنین','قروه درگزین'] },
  { name: 'مرکزی', cities: ['اراک','ساوه','خمین','محلات','دلیجان','شازند','فرمهین','تفرش','آشتیان','زرندیه','کمیجان','خنداب'] },
  { name: 'قزوین', cities: ['قزوین','تاکستان','آبیک','بوئین‌زهرا','آوج','البرز','محمدیه','شال','اسفرورین','خرمدشت','ضیاءآباد','نرجه'] },
  { name: 'یزد', cities: ['یزد','میبد','اردکان','بافق','مهریز','ابرکوه','تفت','خاتم','اشکذر','بهاباد','مروست'] },
  { name: 'اردبیل', cities: ['اردبیل','پارس‌آباد','خلخال','مشگین‌شهر','گرمی','بیله‌سوار','نمین','نیر','کوثر','سرعین','اصلاندوز','هیر'] },
  { name: 'بوشهر', cities: ['بوشهر','برازجان','بندر گناوه','بندر دیر','کنگان','جم','خورموج','آب‌پخش','اهرم','دیلم','عسلویه','تنگستان','دشتی','دلوار','بندر ریگ'] },
  { name: 'زنجان', cities: ['زنجان','ابهر','خرمدره','قیدار','هیدج','صائین‌قلعه','سلطانیه','ماه‌نشان','طارم','ایجرود','زنجان‌رود'] },
  { name: 'سمنان', cities: ['سمنان','شاهرود','گرمسار','دامغان','مهدی‌شهر','بسطام','میامی','آرادان','سرخه','مجن','بیارجمند'] },
  { name: 'چهارمحال و بختیاری', cities: ['شهرکرد','بروجن','فارسان','لردگان','سامان','اردل','بن','کیار','کوهرنگ'] },
  { name: 'کهگیلویه و بویراحمد', cities: ['یاسوج','دوگنبدان','دهدشت','سی‌سخت','لیکک','چرام','باشت','مارگون','بهمئی'] },
  { name: 'ایلام', cities: ['ایلام','دهلران','آبدانان','دره‌شهر','مهران','ایوان','چرداول','ملکشاهی','سیروان','بدره'] },
  { name: 'خراسان شمالی', cities: ['بجنورد','شیروان','اسفراین','آشخانه','گرمه','جاجرم','فاروج','راز','صخره','بام و صفی‌آباد'] },
  { name: 'خراسان جنوبی', cities: ['بیرجند','قائن','فردوس','نهبندان','طبس','بشرویه','سربیشه','درمیان','خوسف','زیرکوه','سرایان'] },
];

/* ================================================================
   🔧 HELPERS
   ================================================================ */
const pad2 = (n) => String(n).padStart(2, '0');
const localYMD = (d = new Date()) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
const startOfDayMs = (d = new Date()) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
const startOfJalaliWeekMs = () => {
  const now = new Date();
  const dow = now.getDay(); // 0=Sun, 6=Sat
  const daysSinceSat = (dow + 1) % 7;
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysSinceSat).getTime();
};
const startOfYearMs = (d = new Date()) => new Date(d.getFullYear(), 0, 1).getTime();
const getLeagueIdxByScore = (xp) => { let i = 0; DRAGONS.forEach((d, k) => { if (xp >= d.minScore) i = k; }); return i; };
const getDragonById = (id) => DRAGONS.find(d => d.id === id) || DRAGONS[0];
const getDragonForXp = (xp) => DRAGONS[getLeagueIdxByScore(xp || 0)];

function getSecondsToMidnight() {
  const now = new Date();
  const mid = new Date(now); mid.setHours(24, 0, 0, 0);
  return Math.max(0, Math.floor((mid.getTime() - now.getTime()) / 1000));
}
function formatTimer(t) {
  const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
  return `${pad2(h)}:${pad2(m)}:${pad2(s)}`;
}

function getExamDateStr(exam) {
  if (!exam) return '';
  const raw = exam.date || exam.startTime || exam._gregorianDate || '';
  return String(raw).split('T')[0];
}

/* ================================================================
   🪝 HOOKS — دیتای واقعی از سرور
   ================================================================ */
function useUserCourses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const token = getToken();
      const res = await fetch('/api/db/appData', { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setCourses(Array.isArray(data.courses) ? data.courses : []);
    } catch (e) {
      console.warn('⚠️ courses fetch failed:', e);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  return { courses, loading, refresh };
}

function useAllUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const token = getToken();
        const res = await fetch('/api/db/users', { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) return;
        const data = await res.json();
        if (Array.isArray(data)) setUsers(data);
      } catch (e) { console.warn('⚠️ users fetch failed:', e); }
    })();
  }, []);
  return users;
}

function useAllRewards() {
  const [rewards, setRewards] = useState({});
  useEffect(() => {
    (async () => {
      try {
        const token = getToken();
        const res = await fetch('/api/db/userRewards', { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) return;
        const data = await res.json();
        const map = {};
        (Array.isArray(data) ? data : []).forEach(r => { if (r?.userId) map[String(r.userId)] = r; });
        setRewards(map);
      } catch (e) { console.warn('⚠️ rewards fetch failed:', e); }
    })();
  }, []);
  return rewards;
}

function useDailyChallenge(exams, userId) {
  return useMemo(() => {
    const todayGreg = new Date().toISOString().split('T')[0];
    const todayJal = moment().format('jYYYY-jMM-jDD');
    const exam = (exams || []).find(e => {
      if (!e || e.isStepQuiz) return false;
      if (e.statusType !== 'active') return false;
      if (e.isDailyChallenge !== true) return false;
      const d = getExamDateStr(e);
      return d === todayGreg || d === todayJal;
    });
    if (!exam) return null;
    const result = (exam.results || []).find(r => String(r.studentId) === String(userId));
    return {
      examId: exam.id,
      title: exam.title || 'چالش امروز',
      description: exam.description || `در ${exam.questions?.length || 10} سوال مهارتت را ثابت کن`,
      rewardXP: exam.rewardXP || 100,
      questionsCount: exam.questions?.length || 10,
      completed: result?.isFinalSubmit === true,
    };
  }, [exams, userId]);
}

/* ================================================================
   🎯 MISSION ENGINE — محاسبه واقعی پیشرفت هر ماموریت
   ================================================================ */
function computeDailyMissions({ user, exams, courses, now }) {
  if (!user?.id) return [];

  const todayStartMs = startOfDayMs(now);
  const todayEndMs = todayStartMs + 86400000;

  const isResultToday = (r) => {
    if (!r?.isFinalSubmit) return false;
    if (!r.submittedAt) return false;
    const t = new Date(r.submittedAt).getTime();
    return t >= todayStartMs && t < todayEndMs;
  };

  /* ۱. چالش‌های روزانه */
  let challengesToday = 0;
  (exams || []).forEach(exam => {
    if (!exam || exam.isStepQuiz) return;
    if (!exam.isChallenge) return;
    if (exam.statusType === 'archived') return;
    const r = (exam.results || []).find(x => String(x.studentId) === String(user.id));
    if (isResultToday(r)) challengesToday++;
  });

  /* ۲. آزمون */
  let examsToday = 0;
  (exams || []).forEach(exam => {
    if (!exam || exam.isStepQuiz) return;
    if (exam.isChallenge) return;
    if (exam.statusType === 'archived') return;
    const r = (exam.results || []).find(x => String(x.studentId) === String(user.id));
    if (isResultToday(r)) examsToday++;
  });

  /* ۳. ویدیو — ترجیح سرور، fallback به localStorage */
  let videoToday = false;
  try {
    const serverProgress =
      user.lessonProgress &&
      typeof user.lessonProgress === 'object' &&
      Object.keys(user.lessonProgress).length > 0
        ? user.lessonProgress
        : null;

    if (serverProgress) {
      for (const prog of Object.values(serverProgress)) {
        if (!prog) continue;
        if (!Array.isArray(prog.completedStepIds) || prog.completedStepIds.length === 0) continue;
        if (!prog.lastVisitedAt) continue;
        const t = Number(prog.lastVisitedAt);
        if (t >= todayStartMs && t < todayEndMs) { videoToday = true; break; }
      }
    } else {
      let keys = [];
      try {
        keys = engine.keys(`lesson-progress-${user.id}-`) || [];
      } catch {
        keys = [];
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (k && k.startsWith(`lesson-progress-${user.id}-`)) keys.push(k);
        }
      }
      for (const key of keys) {
        let prog = null;
        try { prog = engine.get(key, null); }
        catch { try { prog = JSON.parse(localStorage.getItem(key)); } catch {} }
        if (!prog) continue;
        if (!Array.isArray(prog.completedStepIds) || prog.completedStepIds.length === 0) continue;
        if (!prog.lastVisitedAt) continue;
        const t = Number(prog.lastVisitedAt);
        if (t >= todayStartMs && t < todayEndMs) { videoToday = true; break; }
      }
    }
  } catch {}

  /* ۴. کلاس خصوصی امروز */
  let classToday = false;
  const enrolled = Array.isArray(user.enrolledCourses) ? user.enrolledCourses : [];
  (courses || []).forEach(course => {
    if (!enrolled.includes(course.id)) return;
    if (course.status !== 'live' && course.status !== 'ended') return;
    if (!course.date) return;
    try {
      const cm = moment(course.date, 'jYYYY-jMM-jDD');
      if (!cm.isValid()) return;
      const today = moment(now).startOf('day');
      if (cm.isSame(today, 'day')) classToday = true;
    } catch {}
  });

  /* ۵. برنامه درسی روزانه — هوشمند، ترجیح سرور */
  const todayUTC = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString().split('T')[0];
  let todayPlan = null;

  try {
    let plans = null;
    if (Array.isArray(user.curriculumPlans) && user.curriculumPlans.length > 0) {
      plans = user.curriculumPlans;
    } else {
      const plansStr = localStorage.getItem(`curriculum_plans_${user.id}`);
      if (plansStr) plans = JSON.parse(plansStr);
    }
    if (Array.isArray(plans)) {
      for (const plan of plans) {
        if (!plan?.days) continue;
        const todayEntry = plan.days.find(d => d.date === todayUTC);
        if (todayEntry) {
          todayPlan = { plan, todayEntry };
          break;
        }
      }
    }
  } catch {}

  let planMission;
  if (!todayPlan) {
    // هیچ برنامه‌ای برای این هفته نیست → بساز
    planMission = {
      id: 'plan_create',
      icon: '📝',
      title: 'برنامه درسی هفتگی',
      desc: 'یک برنامه درسی برای این هفته بساز',
      xp: 30,
      target: 1,
      progress: 0,
      href: '/Lesson-planning',
    };
  } else {
    const sessions = Array.isArray(todayPlan.todayEntry.sessions) ? todayPlan.todayEntry.sessions : [];
    const doneCount = sessions.filter(s => s.done === true).length;
    const totalCount = sessions.length;

    if (totalCount === 0) {
      planMission = {
        id: 'plan_today',
        icon: '📖',
        title: 'برنامه درسی روزانه',
        desc: 'برنامه امروزت را با جلسات مطالعه پر کن',
        xp: 20,
        target: 1,
        progress: 0,
        href: '/Lesson-planning',
      };
    } else {
      const pct = Math.round((doneCount / totalCount) * 100);
      planMission = {
        id: 'plan_today',
        icon: '📖',
        title: 'برنامه درسی روزانه',
        desc: doneCount >= totalCount
          ? '✅ برنامه امروزت را کامل کردی!'
          : `امروز ${doneCount} از ${totalCount} جلسه را کامل کن (${pct}%)`,
        xp: 20,
        target: totalCount,
        progress: doneCount,
        href: '/Lesson-planning',
      };
    }
  }

  return [
    { id: 'challenges', icon: '⭐', title: '۳ چالش روزانه', desc: 'امروز ۳ چالش را کامل کن', xp: 100, target: 3, progress: Math.min(challengesToday, 3), href: '/challenge' },
    { id: 'exam', icon: '📝', title: 'شرکت در آزمون', desc: 'امروز در یک آزمون شرکت کن', xp: 50, target: 1, progress: Math.min(examsToday, 1), href: '/exams/student' },
    { id: 'video', icon: '📚', title: 'دیدن ویدیو آموزشی', desc: 'یک ویدیوی آموزشی ببین', xp: 30, target: 1, progress: videoToday ? 1 : 0, href: '/books' },
    { id: 'class', icon: '👨‍🏫', title: 'کلاس خصوصی', desc: 'در یک کلاس خصوصی امروز شرکت کن', xp: 40, target: 1, progress: classToday ? 1 : 0, href: '/private-class/student' },
    planMission,
  ];
}

function computeWeeklyMissions({ user, exams, courses, streak }) {
  if (!user?.id) return [];
  const weekStartMs = startOfJalaliWeekMs();

  /* ۱. استریک ۷ روزه */
  const streakProgress = Math.min(streak || 0, 7);

  /* ۲. کلاس خصوصی هفتگی */
  let classThisWeek = 0;
  const enrolled = Array.isArray(user.enrolledCourses) ? user.enrolledCourses : [];
  (courses || []).forEach(course => {
    if (!enrolled.includes(course.id)) return;
    if (course.status !== 'live' && course.status !== 'ended') return;
    if (!course.date) return;
    try {
      const cm = moment(course.date, 'jYYYY-jMM-jDD');
      if (!cm.isValid()) return;
      if (cm.valueOf() >= weekStartMs) classThisWeek++;
    } catch {}
  });

  /* ۳. ۵۰۰ امتیاز آزمون هفتگی */
  let examPointsThisWeek = 0;
  (exams || []).forEach(exam => {
    if (!exam || exam.isStepQuiz) return;
    const r = (exam.results || []).find(x => String(x.studentId) === String(user.id));
    if (!r?.isFinalSubmit || !r.submittedAt) return;
    const t = new Date(r.submittedAt).getTime();
    if (t >= weekStartMs) examPointsThisWeek += (Number(r.score) || 0);
  });

  return [
    { id: 'streak7', icon: '🔥', title: 'استریک ۷ روزه', desc: '۷ روز متوالی فعال باش', xp: 300, target: 7, progress: streakProgress, href: null },
    { id: 'weekly-class', icon: '👨‍🏫', title: 'کلاس خصوصی هفتگی', desc: 'این هفته در یک کلاس خصوصی شرکت کن', xp: 200, target: 1, progress: Math.min(classThisWeek, 1), href: '/private-class/student' },
    { id: 'weekly-points', icon: '⚡', title: '۵۰۰ امتیاز آزمون هفتگی', desc: 'این هفته ۵۰۰ امتیاز از آزمون‌ها جمع کن', xp: 250, target: 500, progress: Math.min(examPointsThisWeek, 500), href: '/exams/student' },
  ];
}

/* ================================================================
   🗺️ LOCATION PICKER
   ================================================================ */
function LocationPicker({ type, province, onSelect, onClose, saving }) {
  const [search, setSearch] = useState('');
  const options = useMemo(() => {
    if (type === 'province') return IRAN_PROVINCES.map(p => p.name);
    const p = IRAN_PROVINCES.find(x => x.name === province);
    return p?.cities || [];
  }, [type, province]);
  const filtered = useMemo(() => options.filter(o => o.includes(search.trim())), [options, search]);

  return (
    <div className="loc-picker-overlay" onClick={e => e.target === e.currentTarget && !saving && onClose()}>
      <div className="loc-picker">
        <div className="loc-picker-header">
          <h3>{type === 'province' ? 'استان خود را انتخاب کنید' : `شهر خود در استان ${province} را انتخاب کنید`}</h3>
          <button className="loc-picker-close" onClick={onClose} disabled={saving}>✕</button>
        </div>
        <input className="loc-picker-search" placeholder="جستجو..." value={search} onChange={e => setSearch(e.target.value)} autoFocus />
        <div className="loc-picker-list">
          {saving ? (
            <div className="loc-picker-empty">در حال ذخیره...</div>
          ) : filtered.length === 0 ? (
            <div className="loc-picker-empty">موردی یافت نشد</div>
          ) : filtered.map(name => (
            <button key={name} className="loc-picker-item" onClick={() => onSelect(name)}>{name}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ================================================================
   ⏱️ DAILY CHALLENGE BANNER
   ================================================================ */
const DailyChallengeSection = React.memo(function DailyChallengeSection({ challenge, loading, onStart }) {
  const [seconds, setSeconds] = useState(() => getSecondsToMidnight());
  useEffect(() => {
    const id = setInterval(() => setSeconds(getSecondsToMidnight()), 1000);
    return () => clearInterval(id);
  }, []);
  const progress = Math.max(0, Math.min(100, ((86400 - seconds) / 86400) * 100));

  if (loading) {
    return (
      <section className="daily-challenge daily-challenge--loading">
        <div className="dc-icon-wrap"><div className="dc-icon">⚔️</div></div>
        <div className="dc-info">
          <div className="dc-label">چالش روزانه</div>
          <div className="dc-title">در حال بارگذاری...</div>
        </div>
      </section>
    );
  }
  if (!challenge) {
    return (
      <section className="daily-challenge" style={{ opacity: 0.6 }}>
        <div className="dc-icon-wrap"><div className="dc-icon">📭</div></div>
        <div className="dc-info">
          <div className="dc-label">چالش روزانه</div>
          <div className="dc-title">هیچ چالش روزانه‌ای فعال نیست</div>
          <div className="dc-desc">می‌توانی از چالش‌های آزاد استفاده کنی</div>
        </div>
      </section>
    );
  }

  return (
    <section className="daily-challenge">
      <div className="dc-icon-wrap">
        <div className="dc-icon-glow" aria-hidden="true"></div>
        <div className="dc-icon">{challenge.completed ? '✅' : '⚔️'}</div>
      </div>
      <div className="dc-info">
        <div className="dc-label">چالش روزانه</div>
        <h2 className="dc-title">{challenge.title}</h2>
        <p className="dc-desc">{challenge.description}</p>
      </div>
      <div className="dc-timer">
        <div className="dc-timer-label"><i className="fas fa-hourglass-half"></i> زمان باقی‌مانده</div>
        <div className="dc-timer-value">{formatTimer(seconds)}</div>
        <div className="dc-timer-bar"><div className="dc-timer-fill" style={{ width: `${progress}%` }} /></div>
      </div>
      <button className="dc-cta" onClick={onStart}>
        <i className={`fas ${challenge.completed ? 'fa-eye' : 'fa-bolt'}`}></i>
        {challenge.completed ? 'مشاهده' : 'شروع مبارزه'}
      </button>
    </section>
  );
});

/* ================================================================
   🏆 LEADERBOARD — واقعی
   ================================================================ */
const LeaderboardContent = React.memo(function LeaderboardContent({ leaderboard, loading, error, onRetry, timeFilter, setTimeFilter, locFilter, onLocChange, profile, onChangeLocation }) {
  const filters = (
    <div className="filters">
      <div className="filter-group">
        {[{ k: 'today', label: 'امروز' }, { k: 'week', label: 'این هفته' }, { k: 'year', label: 'سال' }].map(o => (
          <button key={o.k} className={`filter-btn time ${timeFilter === o.k ? 'active' : ''}`} onClick={() => setTimeFilter(o.k)}>{o.label}</button>
        ))}
      </div>
      <div className="filter-group">
        {[{ k: 'country', label: 'کل کشور' }, { k: 'province', label: 'استان' }, { k: 'city', label: 'شهر' }].map(o => (
          <button key={o.k} className={`filter-btn loc ${locFilter === o.k ? 'active' : ''}`} onClick={() => onLocChange(o.k)}>{o.label}</button>
        ))}
      </div>
      {(locFilter === 'province' || locFilter === 'city') && (
        <div className="loc-current">
          <span className="loc-current-label">
            {locFilter === 'province' ? (profile.province || 'انتخاب نشده') : `${profile.province || '—'}، ${profile.city || '—'}`}
          </span>
          <button className="loc-change-btn" onClick={onChangeLocation}>
            <i className="fas fa-edit"></i> تغییر
          </button>
        </div>
      )}
    </div>
  );

  if (loading) return <>{filters}<div className="lb-loading"><div className="lb-spinner"></div><p>در حال بارگذاری...</p></div></>;
  if (error) return <>{filters}<div className="lb-error"><p>خطا در بارگذاری</p><button onClick={onRetry}>تلاش مجدد</button></div></>;

  const { users, myRank } = leaderboard;
  if (!users || users.length === 0) {
    return <>{filters}<div className="lb-empty"><p>هنوز نفری در این جدول ثبت نشده است</p></div></>;
  }

  const top3 = users.slice(0, 3);
  const rest = users.slice(3, 14);
  const me = users.find(u => u.isMe);
  const inTop14 = myRank > 0 && myRank <= 14;
  const order = [1, 0, 2];

  return (
    <>
      {filters}
      <div className="podium">
        {order.map(i => {
          const u = top3[i];
          if (!u) return null;
          const lg = getDragonById(u.leagueId);
          const place = i + 1;
          return (
            <div key={u.id} className={`podium-item p${place} ${u.isMe ? 'is-me' : ''}`}>
              <div className="podium-medal"></div>
              <div className="podium-dragon">
  {lg.image ? (
    <img
      src={lg.image}
      alt={lg.name}
      className="podium-dragon-img"
      draggable={false}
    />
  ) : (
    lg.emoji
  )}
</div>
              <div className="podium-name">{u.name}</div>
              <div className="podium-score">{u.score.toLocaleString()}</div>
              <div className="podium-base" style={{ background: `linear-gradient(180deg, ${lg.c1}, ${lg.c2})` }} />
            </div>
          );
        })}
      </div>
      <div className="ranklist">
        {rest.map((u, i) => {
          const rank = i + 4;
          const lg = getDragonById(u.leagueId);
          return (
            <div key={u.id} className={`rankrow ${u.isMe ? 'is-me' : ''}`}>
              <span className="ranknum">{rank}</span>
              <span className="rankdragon" style={{ background: `linear-gradient(135deg, ${lg.c1}, ${lg.c2})` }}>
  {lg.image ? (
    <img src={lg.image} alt={lg.name} className="rankdragon-img" draggable={false} />
  ) : (
    lg.emoji
  )}
</span>
              <span className="rankname">{u.name}</span>
              <span className="rankscore">{u.score.toLocaleString()}</span>
            </div>
          );
        })}
      </div>
      {!inTop14 && me && (
        <div className="myrrank">
          <div className="myrrank-label">رتبه‌ی شما</div>
          <div className="rankrow is-me">
            <span className="ranknum">{myRank.toLocaleString()}</span>
            <span className="rankdragon" style={{ background: `linear-gradient(135deg, ${getDragonById(me.leagueId).c1}, ${getDragonById(me.leagueId).c2})` }}>
  {getDragonById(me.leagueId).image ? (
    <img src={getDragonById(me.leagueId).image} alt={getDragonById(me.leagueId).name} className="rankdragon-img" draggable={false} />
  ) : (
    getDragonById(me.leagueId).emoji
  )}
</span>
            <span className="rankname">{me.name}</span>
            <span className="rankscore">{me.score.toLocaleString()}</span>
          </div>
        </div>
      )}
    </>
  );
});

/* ================================================================
   🚀 MAIN COMPONENT
   ================================================================ */
export default function MedalsPage() {
  const navigate = useNavigate();
  const { xp = 0, addXp } = useCoins();
  const { user, updateUser } = useAuth();
  const { exams } = useExams();
  const { courses, loading: coursesLoading } = useUserCourses();
  const allUsers = useAllUsers();
  const allRewards = useAllRewards();

  const currentLeagueIdx = useMemo(() => getLeagueIdxByScore(xp || 0), [xp]);
  const [dragonIdx, setDragonIdx] = useState(currentLeagueIdx);
  const [currentTab, setCurrentTab] = useState('missions');
  const [missionTab, setMissionTab] = useState('daily');
  const [timeFilter, setTimeFilter] = useState('today');
  const [locFilter, setLocFilter] = useState('country');
  const [isAnimating, setIsAnimating] = useState(false);
const [pickerType, setPickerType] = useState(null);
const [saving, setSaving] = useState(false);
const [saveError, setSaveError] = useState(null);
const [celebratingDragon, setCelebratingDragon] = useState(null);

const progressFillRef = useRef(null);
const firstRender = useRef(true);
const rewardedThisSession = useRef(new Set());
const celebrationCheckedRef = useRef(false);

  const todayYMD = localYMD(new Date());
  const streak = Number(user?.streak) || 0;

  const dailyChallenge = useDailyChallenge(exams, user?.id);

const dailyMissions = useMemo(
  () => computeDailyMissions({ user, exams, courses, now: new Date() }),
  [
    user?.id,
    user?.enrolledCourses,
    user?.lessonProgress,
    user?.curriculumPlans,
    user?.rewardedMissions,
    exams,
    courses,
  ]
);
const weeklyMissions = useMemo(
  () => computeWeeklyMissions({ user, exams, courses, streak }),
  [
    user?.id,
    user?.enrolledCourses,
    exams,
    courses,
    streak,
  ]
);

  const currentMissions = missionTab === 'daily' ? dailyMissions : weeklyMissions;
  const currentDone = currentMissions.filter(m => m.progress >= m.target).length;

  /* ---------- EFFECT: جایزه دادن ---------- */
  useEffect(() => {
    if (!user?.id) return;
    const existing = Array.isArray(user.rewardedMissions) ? user.rewardedMissions : [];
    const recentRewarded = existing.filter(r => {
      if (!r?.date) return false;
      const t = new Date(r.date).getTime();
      return !isNaN(t) && (Date.now() - t) < 8 * 86400000;
    });
    const rewardedTodayIds = new Set(recentRewarded.filter(r => r.date === todayYMD).map(r => r.id));

    const toReward = [];
    for (const m of [...dailyMissions, ...weeklyMissions]) {
      if (!m || m.progress < m.target) continue;
      if (rewardedTodayIds.has(m.id)) continue;
      const key = `${m.id}_${todayYMD}`;
      if (rewardedThisSession.current.has(key)) continue;
      rewardedThisSession.current.add(key);
      toReward.push(m);
    }
    if (toReward.length === 0) return;

    const totalXp = toReward.reduce((s, m) => s + (m.xp || 0), 0);
    const newRewarded = [
      ...recentRewarded,
      ...toReward.map(m => ({ id: m.id, date: todayYMD })),
    ];
    updateUser({ rewardedMissions: newRewarded });
    addXp(totalXp);
  }, [dailyMissions, weeklyMissions, user?.id, todayYMD, updateUser, addXp]);

    /* ---------- EFFECT: XP برای ساخت برنامه هفتگی ---------- */
  useEffect(() => {
    if (!user?.id) return;
    const todayYMD = localYMD(new Date());
    const existing = Array.isArray(user.rewardedMissions) ? user.rewardedMissions : [];
    const alreadyRewarded = existing.some(r => r.id === 'plan_create' && r.date === todayYMD);
    if (alreadyRewarded) return;

    let plans = null;
    if (Array.isArray(user.curriculumPlans) && user.curriculumPlans.length > 0) {
      plans = user.curriculumPlans;
    } else {
      try {
        const stored = localStorage.getItem(`curriculum_plans_${user.id}`);
        if (stored) plans = JSON.parse(stored);
      } catch {}
    }
    if (!Array.isArray(plans) || plans.length === 0) return;

    const now = new Date();
    const createdToday = plans.some(plan => {
      if (!plan?.createdAt) return false;
      try {
        const c = new Date(plan.createdAt);
        return c.getFullYear() === now.getFullYear()
          && c.getMonth() === now.getMonth()
          && c.getDate() === now.getDate();
      } catch { return false; }
    });
    if (!createdToday) return;

    updateUser({
  rewardedMissions: [...existing, { id: 'plan_create', date: todayYMD }]
});
// با تأخیر کوچک، تضمین می‌شود cooldown با Effect پاداش‌دهی تداخل نکند
setTimeout(() => addXp(30), 300);
}, [user?.id, user?.curriculumPlans, user?.rewardedMissions, updateUser, addXp]);







    /* ---------- EFFECT: همگام‌سازی کامل با سرور (plans + progress) ---------- */
  useEffect(() => {
    if (!user?.id) return;

    // === همگام‌سازی برنامه‌های درسی (دوطرفه) ===
    try {
      const localKey = `curriculum_plans_${user.id}`;
      const localRaw = localStorage.getItem(localKey);
      const localPlans = localRaw ? JSON.parse(localRaw) : [];
      const serverPlans = Array.isArray(user.curriculumPlans) ? user.curriculumPlans : [];

      const localStr = JSON.stringify(localPlans);
      const serverStr = JSON.stringify(serverPlans);

      if (localStr !== serverStr) {
        const getMax = (arr) => arr.length > 0
          ? Math.max(...arr.map(p => new Date(p?.createdAt || 0).getTime()))
          : 0;
        const localMax = getMax(localPlans);
        const serverMax = getMax(serverPlans);

        if (localMax > serverMax) {
          updateUser({ curriculumPlans: localPlans });
        } else if (serverMax > localMax) {
          try { localStorage.setItem(localKey, serverStr); } catch {}
        }
      }
    } catch (e) { console.warn('[MedalsPage] plans sync failed:', e); }

    // === همگام‌سازی پیشرفت دروس (دوطرفه) ===
    try {
      const prefix = `lesson-progress-${user.id}-`;
      const localMap = {};
      let keys = [];
      try {
        keys = engine.keys(prefix) || [];
      } catch {
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (k && k.startsWith(prefix)) keys.push(k);
        }
      }
      for (const k of keys) {
        try {
          const p = engine.get(k, null);
          if (p) localMap[k] = p;
        } catch {}
      }

      const serverMap =
        user.lessonProgress && typeof user.lessonProgress === 'object'
          ? user.lessonProgress
          : {};

      const localStr = JSON.stringify(localMap);
      const serverStr = JSON.stringify(serverMap);

      if (localStr !== serverStr) {
        const getMaxTs = (m) => {
          const vals = Object.values(m).filter(v => v && v.lastVisitedAt);
          return vals.length > 0 ? Math.max(...vals.map(v => Number(v.lastVisitedAt) || 0)) : 0;
        };
        const localMax = getMaxTs(localMap);
        const serverMax = getMaxTs(serverMap);

        if (localMax > serverMax) {
          updateUser({ lessonProgress: localMap });
        } else if (serverMax > localMax) {
          for (const [key, value] of Object.entries(serverMap)) {
            if (key.startsWith(prefix)) {
              try { engine.set(key, value); } catch {}
            }
          }
        }
      }
    } catch (e) { console.warn('[MedalsPage] progress sync failed:', e); }
  }, [user?.id, user?.curriculumPlans, user?.lessonProgress, updateUser]);

  /* ---------- EFFECT: استریک خودکار ---------- */
  useEffect(() => {
    if (!user?.id) return;
    const anyActivity = dailyMissions.some(m => m.progress > 0);
    if (!anyActivity) return;
    if (user.lastActivityDate === todayYMD) return;

    const yesterday = new Date(Date.now() - 86400000);
    const yesterdayYMD = localYMD(yesterday);
    const newStreak = user.lastActivityDate === yesterdayYMD ? (Number(user.streak) || 0) + 1 : 1;
    updateUser({ streak: newStreak, lastActivityDate: todayYMD });
  }, [dailyMissions, user?.id, user?.lastActivityDate, todayYMD, updateUser]);









    /* ---------- EFFECT: جشن باز شدن اژدها (یک‌بار per dragon) ---------- */
  useEffect(() => {
    if (!user?.id) return;
    if (xp === undefined || xp === null) return;
    if (celebrationCheckedRef.current) return;

    const currentDragon = getDragonForXp(Number(xp) || 0);
    if (!currentDragon) return;

    celebrationCheckedRef.current = true;

    if (currentDragon.minScore <= 0) return;

    const serverList = Array.isArray(user.celebratedDragons) ? user.celebratedDragons : [];
    let localList = [];
    try {
      const raw = localStorage.getItem(`celebratedDragons_${user.id}`);
      if (raw) localList = JSON.parse(raw) || [];
    } catch {}
    const merged = Array.from(new Set([...serverList, ...localList]));

    if (merged.includes(currentDragon.id)) return;

    const newList = [...merged, currentDragon.id];

    const trigger = () => {
      try {
        localStorage.setItem(`celebratedDragons_${user.id}`, JSON.stringify(newList));
      } catch {}
      updateUser({ celebratedDragons: newList });
      setCelebratingDragon(currentDragon);
    };

    if (currentDragon.image) {
      const img = new Image();
      let fired = false;
      const go = () => {
        if (fired) return;
        fired = true;
        trigger();
      };
      img.onload = go;
      img.onerror = go;
      img.src = currentDragon.image;
      setTimeout(go, 1500);
    } else {
      trigger();
    }
    
  }, [user?.id, xp]);



  /* ---------- EFFECT: تم ---------- */
  useEffect(() => {
    const dragon = DRAGONS[dragonIdx];
    const root = document.querySelector('.medalspage');
    root.style.setProperty('--dragon-glow', dragon.glow);
    root.style.setProperty('--dragon-c1', dragon.c1);
    root.style.setProperty('--dragon-c2', dragon.c2);
    return () => {
      root.style.removeProperty('--dragon-glow');
      root.style.removeProperty('--dragon-c1');
      root.style.removeProperty('--dragon-c2');
    };
  }, [dragonIdx]);

  useEffect(() => {
    document.documentElement.classList.add('medals-scroll-thin');
    return () => document.documentElement.classList.remove('medals-scroll-thin');
  }, []);

  useEffect(() => {
    if (firstRender.current) { firstRender.current = false; return; }
    setIsAnimating(false);
    const t = setTimeout(() => setIsAnimating(true), 20);
    return () => clearTimeout(t);
  }, [dragonIdx]);

  useEffect(() => {
    const dragon = DRAGONS[dragonIdx];
    const isFuture = dragonIdx > currentLeagueIdx;
    if (!isFuture || !progressFillRef.current) return;
    const prev = DRAGONS[dragonIdx - 1].minScore;
    const pct = Math.max(0, Math.min(100, Math.round(((xp - prev) / (dragon.minScore - prev)) * 100)));
    const el = progressFillRef.current;
    el.style.width = '0%';
    void el.offsetWidth;
    const timer = setTimeout(() => { el.style.width = `${pct}%`; }, 40);
    return () => clearTimeout(timer);
  }, [dragonIdx, currentLeagueIdx, xp]);

  useEffect(() => {
    const handleKey = (e) => {
      if (pickerType) return;
      if (e.key === 'ArrowRight') setDragonIdx(i => Math.max(0, i - 1));
      if (e.key === 'ArrowLeft') setDragonIdx(i => Math.min(DRAGONS.length - 1, i + 1));
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [pickerType]);

  /* ---------- Leaderboard real ---------- */
  const leaderboard = useMemo(() => {
    if (!Array.isArray(allUsers) || allUsers.length === 0 || !user?.id) {
      return { users: [], myRank: 0 };
    }
    const periodStart = timeFilter === 'today' ? startOfDayMs(new Date())
      : timeFilter === 'week' ? startOfJalaliWeekMs()
      : startOfYearMs(new Date());

    const userScores = allUsers.map(u => {
      let score = 0;
      (exams || []).forEach(exam => {
        if (!exam || exam.isStepQuiz) return;
        const r = (exam.results || []).find(x => String(x.studentId) === String(u.id));
        if (!r?.isFinalSubmit || !r.submittedAt) return;
        const t = new Date(r.submittedAt).getTime();
        if (t >= periodStart) score += (Number(r.score) || 0);
      });
      const userXp = Number(allRewards[String(u.id)]?.xp) || Number(u.xp) || 0;
      const leagueId = getDragonForXp(userXp).id;
      return {
        id: u.id,
        name: u.fullName || u.name || 'کاربر',
        score,
        leagueId,
        province: u.province || null,
        city: u.city || null,
        isMe: String(u.id) === String(user.id),
      };
    });

    let filtered = userScores;
    if (locFilter === 'province' && user?.province) {
      filtered = userScores.filter(u => u.province === user.province);
    } else if (locFilter === 'city' && user?.province && user?.city) {
      filtered = userScores.filter(u => u.province === user.province && u.city === user.city);
    }

    filtered.sort((a, b) => b.score - a.score);
    const myRank = filtered.findIndex(u => u.isMe) + 1;
    return { users: filtered, myRank };
  }, [allUsers, allRewards, exams, timeFilter, locFilter, user?.id, user?.province, user?.city]);

  /* ---------- Handlers ---------- */
  const changeDragon = (delta) => {
    const next = dragonIdx + delta;
    if (next >= 0 && next < DRAGONS.length) setDragonIdx(next);
  };
  const goBack = () => navigate(-1);

const handleStartChallenge = useCallback(() => {
  if (dailyChallenge?.examId) navigate(`/exams/take/${dailyChallenge.examId}`);
  else navigate('/challenge');
}, [dailyChallenge?.examId, navigate]);

const handleLocFilterChange = useCallback((newFilter) => {
  if (newFilter === locFilter) return;
  if (newFilter === 'country') { setLocFilter('country'); return; }
  if (newFilter === 'province') {
    if (!user?.province) { setPickerType('province'); return; }
    setLocFilter('province'); return;
  }
  if (newFilter === 'city') {
    if (!user?.province) { setPickerType('province'); return; }
    if (!user?.city) { setPickerType('city'); return; }
    setLocFilter('city'); return;
  }
}, [locFilter, user?.province, user?.city]);

const handleMissionClick = useCallback((m) => {
  if (!m.href) return;
  navigate(m.href);
}, [navigate]);

  const handleSelectProvince = async (provinceName) => {
    setSaving(true); setSaveError(null);
    try {
      updateUser({ province: provinceName, city: null });
      setTimeout(() => {
        setSaving(false);
        setPickerType('city');
      }, 400);
    } catch (e) {
      setSaving(false);
      setSaveError('ذخیره استان ناموفق بود');
    }
  };

  const handleSelectCity = async (cityName) => {
    setSaving(true); setSaveError(null);
    try {
      updateUser({ city: cityName });
      setTimeout(() => {
        setSaving(false);
        setPickerType(null);
        setLocFilter('city');
      }, 400);
    } catch (e) {
      setSaving(false);
      setSaveError('ذخیره شهر ناموفق بود');
    }
  };

  const handleChangeLocation = useCallback(
  () => setPickerType('province'),
  []
);



  /* ---------- Derived ---------- */
  const dragon = DRAGONS[dragonIdx];
  const isCurrent = dragonIdx === currentLeagueIdx;
  const isPast = dragonIdx < currentLeagueIdx;
  const isFuture = dragonIdx > currentLeagueIdx;
  const computedPct = useMemo(() => {
    if (!isFuture) return 0;
    const prev = DRAGONS[dragonIdx - 1].minScore;
    return Math.max(0, Math.min(100, Math.round(((xp - prev) / (dragon.minScore - prev)) * 100)));
  }, [dragonIdx, isFuture, dragon, xp]);

  /* ================================================================
     RENDER
     ================================================================ */
  return (
    <div className="medalspage">
    <div className="app">
      {/* SANCTUM */}
      <section className="sanctum">
        <div className="sanctum-pillars" aria-hidden="true">
          <div className="pillar left"></div>
          <div className="pillar right"></div>
        </div>
        <div className="sanctum-arch" aria-hidden="true"></div>
        <div className="sanctum-stars" aria-hidden="true"></div>
        <div className="sanctum-aura" style={{ background: `radial-gradient(circle, ${dragon.glow}, transparent 65%)` }} aria-hidden="true"></div>

        <button className="sanctum-back" onClick={goBack} aria-label="بازگشت">
          <i className="fas fa-arrow-right"></i>
        </button>

        <div className="sanctum-head">
          <div className="sanctum-title">
            <i className="fas fa-crown"></i>
            <span>محراب اژدها</span>
          </div>
          <div className="sanctum-xp-badge">
            <span className="sanctum-xp-icon">⚡</span>
            <span className="sanctum-xp-value">{Number(xp || 0).toLocaleString()}</span>
            <span className="sanctum-xp-label">XP</span>
          </div>
        </div>

        <div className="sanctum-stage">
          <div className="spell-ring" aria-hidden="true"></div>
          <div className="floor-ring" aria-hidden="true"></div>

          <button className="sanctum-arrow prev" onClick={() => changeDragon(-1)} disabled={dragonIdx === 0} aria-label="قبلی">
            <i className="fas fa-chevron-right"></i>
          </button>

<div
  className={`dragon-wrap ${isAnimating ? 'animating' : ''}`}
  style={{ top: `${-(dragon.bottom || 0)}px` }}
>
  <div className={`dragon-visual ${isFuture ? 'locked' : ''}`}>
    {dragon.image ? (
      <img
        src={dragon.image}
        alt={dragon.name}
        className="dragon-image"
        draggable={false}
        style={{
          width: `clamp(${dragon.size * 0.65}px, ${dragon.size / 4}vw, ${dragon.size}px)`,
        }}
      />
    ) : (
      <div className="dragon-emoji">{dragon.emoji}</div>
    )}
{isFuture && (
  <div className="dragon-lock" aria-hidden="true">
    <svg className="dragon-lock-svg" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="10" width="16" height="11" rx="3" fill="currentColor" opacity="0.9"/>
      <path d="M8 10V7a4 4 0 1 1 8 0v3" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
      <circle cx="12" cy="15.5" r="1.6" fill="#1a0b2e"/>
      <rect x="11.2" y="16" width="1.6" height="2.4" rx="0.8" fill="#1a0b2e"/>
    </svg>
  </div>
)}
  </div>
  <h1 className="dragon-name">{dragon.name}</h1>
  {isCurrent ? (
    <div className="dragon-tag current">⭐ لیگ فعلی شما</div>
  ) : isPast ? (
    <div className="dragon-tag done">✓ فتح شده</div>
  ) : (
    <div className="dragon-tag locked">🔒 نیاز به {dragon.minScore.toLocaleString()} XP</div>
  )}
  <div className={`sanctum-progress ${isFuture ? '' : 'hidden'}`}>
    <div className="progress-track">
      <div ref={progressFillRef} className="progress-fill" style={{ width: '0%' }} />
    </div>
    
  </div>
</div>

          <button className="sanctum-arrow next" onClick={() => changeDragon(1)} disabled={dragonIdx === DRAGONS.length - 1} aria-label="بعدی">
            <i className="fas fa-chevron-left"></i>
          </button>

          <div className="brazier left" aria-hidden="true"><div className="brazier-flame"></div><div className="brazier-bowl"></div><div className="brazier-stand"></div></div>
          <div className="brazier right" aria-hidden="true"><div className="brazier-flame"></div><div className="brazier-bowl"></div><div className="brazier-stand"></div></div>
        </div>

        <div className="waypoints">
          {DRAGONS.map((d, i) => {
            let cls = 'waypoint';
            if (i === dragonIdx) cls += ' current';
            else if (i < currentLeagueIdx) cls += ' past';
            else cls += ' future';
            return (
              <React.Fragment key={d.id}>
                <button className={cls} onClick={() => setDragonIdx(i)} aria-label={d.name}>
                  <span className="waypoint-icon">{d.emoji}</span>
                  <span className="waypoint-name">{d.name}</span>
                </button>
                {i < DRAGONS.length - 1 && (
                  <span className={i < currentLeagueIdx ? 'waypoint-connector past' : 'waypoint-connector'} />
                )}
              </React.Fragment>
            );
          })}
        </div>

        <div className="sanctum-fog" aria-hidden="true"></div>
      </section>

      {/* CONTAINER */}
      <div className="container">
        <DailyChallengeSection
          challenge={dailyChallenge}
          loading={false}
          onStart={handleStartChallenge}
        />

        <div className="tabs">
          <button className={`tab ${currentTab === 'missions' ? 'active' : ''}`} onClick={() => setCurrentTab('missions')}>
            <span className="tab-icon">🎯</span><span>ماموریت‌ها</span>
          </button>
          <button className={`tab ${currentTab === 'leaderboard' ? 'active' : ''}`} onClick={() => setCurrentTab('leaderboard')}>
            <span className="tab-icon">🏆</span><span>جدول برترین‌ها</span>
          </button>
        </div>

        <div className="panels">
          {/* MISSIONS */}
          <div className={`panel ${currentTab === 'missions' ? 'active' : ''}`}>
            <div className="mission-toggle">
              <button className={`mt-btn daily ${missionTab === 'daily' ? 'active' : ''}`} onClick={() => setMissionTab('daily')}>
                <span className="mt-emoji">☀️</span>
                <span className="mt-info">
                  <span className="mt-name">ماموریت‌های امروز</span>
                  
                </span>
              </button>
              <button className={`mt-btn weekly ${missionTab === 'weekly' ? 'active' : ''}`} onClick={() => setMissionTab('weekly')}>
                <span className="mt-emoji">🌙</span>
                <span className="mt-info">
                  <span className="mt-name">چالش‌های هفته</span>
                  
                </span>
              </button>
            </div>

            <div className="mission-hint">
              <span className="mh-emoji">✨</span>
              <span className="mh-text">
                {missionTab === 'daily'
                  ? 'هر روز ۵ ماموریت جدید منتظرته! با انجام‌شون XP بگیر و اژدهای بزرگ‌تر باز کن'
                  : 'این هفته ۳ چالش بزرگ داری! همه‌شون رو انجام بده تا پاداش ویژه بگیری'}
              </span>
              <span className="mh-emoji">✨</span>
            </div>

            <div className="missions-grid">
              {currentMissions.map((m) => {
                const done = m.progress >= m.target;
                const pct = Math.round((m.progress / m.target) * 100);
                const isWeekly = missionTab === 'weekly';
                return (
                  <div
                    key={m.id}
                    className={`mission ${isWeekly ? 'weekly' : ''} ${done ? 'done' : ''}`}
                    onClick={() => handleMissionClick(m)}
                    style={{ cursor: m.href ? 'pointer' : 'default' }}
                  >
                    <div className="mission-icon">
                      <span className="mission-emoji">{m.icon}</span>
                      {done && <span className="mission-done-badge">✓</span>}
                    </div>
                    <div className="mission-body">
                      <div className="mission-title">{m.title}</div>
                      <div className="mission-desc">{m.desc}</div>
                      <div className="mission-progress">
                        <div className="mission-bar">
                          <div className="mission-fill" style={{ width: `${pct}%` }}>
                            {!done && pct > 15 && <span className="mission-sparkle">✨</span>}
                          </div>
                        </div>
                        <span className="mission-count">
                          {done ? '🎉 آفرین!' : `${m.progress}/${m.target}`}
                        </span>
                      </div>
                    </div>
                    <div className="mission-reward">
                      <span className="mission-coin">{isWeekly ? '💎' : '🪙'}</span>
                      <span className="mission-xp">+{m.xp}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* LEADERBOARD */}
          <div className={`panel ${currentTab === 'leaderboard' ? 'active' : ''}`}>
            <LeaderboardContent
              leaderboard={leaderboard}
              loading={false}
              error={null}
              onRetry={() => {}}
              timeFilter={timeFilter}
              setTimeFilter={setTimeFilter}
              locFilter={locFilter}
              onLocChange={handleLocFilterChange}
              profile={{ province: user?.province || null, city: user?.city || null }}
              onChangeLocation={handleChangeLocation}
            />
          </div>
        </div>
      </div>

      {pickerType && (
        <LocationPicker
          type={pickerType}
          province={user?.province}
          saving={saving}
          onSelect={pickerType === 'province' ? handleSelectProvince : handleSelectCity}
          onClose={() => { setPickerType(null); setSaveError(null); }}
        />
      )}

      {saveError && <div className="loc-save-error">{saveError}</div>}

      {celebratingDragon && (
        <DragonCelebration
          dragon={celebratingDragon}
          onClose={() => setCelebratingDragon(null)}
        />
      )}
    </div>
    </div>
  );
}